import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import awaitToJs from '@/libs/awaitToJs';
import { toCheckCodes } from '@/api/correspondence/task/form';
import { mapState } from "vuex";
import { transformInputCodes } from "@/util";
export default {
  name: 'before-send',
  data: function data() {
    return {
      form: {
        express: undefined,
        codes: undefined
      },
      list: [],
      loading: false,
      rules: {
        express: [{
          required: true,
          message: '请输入快递单号',
          trigger: 'change'
        }],
        codes: [{
          required: true,
          message: '请录入函证单号,以英文逗号隔开',
          trigger: 'change'
        }]
      },
      errorMsg: undefined,
      successMsg: undefined
    };
  },
  computed: _objectSpread(_objectSpread({
    dataCodes: function dataCodes() {
      var codes = this.form.codes;
      return transformInputCodes(codes);
    }
  }, mapState('cpscc', ['userInfo'])), {}, {
    isHX: function isHX() {
      return this.$store.state.cpscc.isHX;
    },
    isAdmin: function isAdmin() {
      var user = this.userInfo;
      if (user && user.data2) {
        return user.data2.admin;
      }
      return false;
    },
    isCpscAdmin: function isCpscAdmin() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('函证中心管理员');
        }
      }
      return false;
    },
    isSender: function isSender() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('发函操作员');
        }
      }
      return false;
    }
  }),
  methods: {
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$awaitToJs, _yield$awaitToJs2, err;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$checkForm();
            case 1:
              _this.loading = true;
              _this.errorMsg = undefined;
              _this.successMsg = undefined;
              _context.n = 2;
              return awaitToJs(toCheckCodes({
                confirmcodes: _this.dataCodes,
                trackingNo: _this.form.express
              }));
            case 2:
              _yield$awaitToJs = _context.v;
              _yield$awaitToJs2 = _slicedToArray(_yield$awaitToJs, 1);
              err = _yield$awaitToJs2[0];
              _this.loading = false;
              if (!err) {
                _context.n = 3;
                break;
              }
              _this.errorMsg = err.message;
              return _context.a(2);
            case 3:
              _this.successMsg = '函证装袋核验通过，可封袋寄发，同时已将该批函证置为已发出。';
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {}
};